import { useDispatch, useSelector } from "react-redux";
import { setShowOtherModal } from "../../features/modals/modalsSlice";
import DiscountModal from "./DiscountModal";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../const/api";

const DiscountModalUse = () => {
  const [promotions, setPromotions] = useState([]);
  const { i18n } = useTranslation("global");

  useEffect(() => {
    const loadPromociones = async () => {
      try {
        const response = await axios.post(
          API_URL+"loadPromociones"
        );
        console.log(response);

        // Filtrar las promociones por el idioma del usuario
        const filteredPromotions = response.data.response.promociones.filter(
          (promo) => promo.lang === i18n.language
        );
        setPromotions(filteredPromotions);
      } catch (error) {
        console.error("Error al cargar promociones:", error);
        setPromotions([
          {
            titulo: "Error",
            detalle:
              "No se pudo cargar la lista de bonos. Por favor, inténtalo de nuevo más tarde.",
            picture:
              "https://masterbets365.com/static/media/logo.291eacffcd58797e638642a6e44ed6b2.svg",
          },
        ]);
      }
    };

    loadPromociones();
  }, [i18n.language]);

  const dispatch = useDispatch();
  const isOtherModalOpen = useSelector((state) => state.modals.showOtherModal);
  const handleModalClose = () => {
    dispatch(setShowOtherModal(false));
  };

  //URL dinamica para imagenes
  const getImageUrl = (picture) => {
    return `https://admin.betsfactory.co/admin/contenido/${i18n.language}/promociones/${picture}`;
  };
  const discountArrayUpdated = promotions.map((promo) => ({
    title: promo.titulo,
    description: promo.detalle,
    imageUrl: getImageUrl(promo.picture),
  }));
  return (
    <div>
      <DiscountModal
        open={isOtherModalOpen}
        handleClose={handleModalClose}
        discountArray={discountArrayUpdated}
      />
    </div>
  );
};

export default DiscountModalUse;
